<template>
  <div class="row pt-2">
    <div class="col" v-if="actionAccesDecision.modifierUrgenceActionDecision">
      <Button label="Modifier" v-on:click="modifier"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'ButtonBar',
  emits: ['fermer'],
  computed: {
      ...mapGetters({
      actionAccesDecision: 'dossier/actionAccesDecision',
      })
  },
  methods: {
    modifier() {
      this.$router.push({
        name: "modifierUrgence",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>